﻿(function (
  angular,
  location,
  history,
  encodeURIComponent,
  decodeURIComponent,
  setInterval,
  clearInterval,
  ToyotaConsts
) {
  "use strict";

  var ASYNC_HIDE_DURATION_MS = 500;
  var MAX_LOAD_TAGS_QUERY_LENGTH = 3;

  angular.module("Toyota.Directives").directive("tyFindADealerPage", [
    "$timeout",
    "$rootScope",
    function ($timeout, $rootScope) {
      var controller = [
        "$scope",
        "$attrs",
        "$q",
        "$filter",
        "$location",
        "$analytics",
        "Postcodes",
        "API",
        function ($scope, $attrs, $q, $filter, $location, $analytics, Postcodes, API) {
          var ctl = this;
          var dealerCountPerLoad = 12;
          var modalId = "ty-find-a-dealer-filter-modal";
          const urlRegexPattern =
            /^(http(s)?:\/\/)(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}([/?#].*)?$/;
            
          function init() {
            $scope.findADealer = {
              searchOptions: {
                tagfieldTags: [],
                stateFilter: null,
                stateFilterActive: false,
                location: null,
              },
              loadingPromise: null,
              loadingAddressAutocompletions: false,
              loadingDealers: false,
              tagfieldText: "",
              dealersUnfiltered: [],
              dealers: [],
              dealersDisplayed: [],
              dealersFiltered: [],
              dealersFilteredCount: 0,
              cached: {},
              allItemsDisplayed: true,
              refreshDealersAndUrlFragment: refreshDealersAndUrlFragment,
              displayMoreItems: displayMoreItems,
              serviceTypes: JSON.parse($attrs.serviceTypes),
              serviceTypeFilter: {},
            };

            $scope.findADealer.serviceTypes.forEach(function (_serviceType) {
              var serviceType = angular.extend(_serviceType, {
                checked: false,
                savedCheckedState: false,
                disabled: false,
              });

              $scope.findADealer.serviceTypeFilter[serviceType.Service_Type_Name] = serviceType;
            });

            $scope.findADealer.searchOptions = deserializeSearchOptionsFromFragment(getUrlFragment());

            $scope.$watch("findADealer.searchOptions.stateFilter", function () {
              $scope.findADealer.searchOptions.stateFilterActive = true;
              if ($scope.findADealer.searchOptions.location) {
                $scope.findADealer.searchOptions.tagfieldTags = [];
                $scope.findADealer.searchOptions.location = null;
              }

              $scope.findADealer.refreshDealersAndUrlFragment();
            });

            // imitate setLocation a little bit on back-button
            $scope.$watch("findADealer.searchOptions.location", function () {
              if ($scope.findADealer.searchOptions.location) {
                $scope.findADealer.searchOptions.stateFilterActive = false;
              }
            });

            angular.element(window).on("hashchange", function () {
              $timeout(function () {
                var newSearchOptions = getUrlFragment();
                var currentSearchOptions = serializeSearchOptionsForFragment($scope.findADealer.searchOptions);
                if (newSearchOptions !== currentSearchOptions) {
                  $scope.findADealer.searchOptions = deserializeSearchOptionsFromFragment(getUrlFragment());
                  $scope.findADealer.refreshDealersAndUrlFragment();
                }
              });
            });
          }

          ctl.serviceTypeFilterChanged = function (name) {
            filterResults($scope.findADealer.dealersUnfiltered);

            if ($scope.findADealer.serviceTypeFilter[name].checked) {
              ctl.track("Filters", $filter("formatArgs")("Service Type Filters - {0}", [name]));
            }
          };

          ctl.showFilter = function () {
            return $scope.findADealer.searchOptions.stateFilterActive && $scope.findADealer.dealers.length > 0;
          };

          ctl.closeModal = function (noTrack) {
            $rootScope.$broadcast("modal-close", modalId);

            if (!noTrack) {
              ctl.track("Filters", "Close");
            }
          };

          ctl.showModal = function () {
            $rootScope.$broadcast("modal-open", modalId);
            ctl.track("Filters", "Open");
          };

          $scope.$on("modal-close", function (event, id) {
            if (modalId !== id) {
              return;
            }

            ctl.resetServiceTypeFilter();
          });

          ctl.hasFilteredResults = function () {
            return $scope.findADealer.dealersFilteredCount > 0;
          };

          ctl.getTotalFilteredResults = function () {
            return $scope.findADealer.dealersCountDisplayed;
          };

          ctl.getTotalFiltersSelected = function () {
            return getFilterArray().length;
          };

          ctl.getTotalFiltersApplied = function () {
            return getAppliedFilterArray().length;
          };

          ctl.loadTags = function (query) {
            $scope.findADealer.queryLength = query.length;

            if (query.length === 0) {
              if ($scope.findADealer.searchOptions.tagfieldTags.length === 0) {
                $scope.findADealer.loadingAddressAutocompletions = false;
              }
            }

            if (query.length < MAX_LOAD_TAGS_QUERY_LENGTH) {
              var deferred = $q.defer();
              deferred.resolve([]);
              return deferred.promise;
            }

            $scope.findADealer.loadingAddressAutocompletions = true;
            var maxResults = $attrs.maxResults;
            return Postcodes(query, maxResults).then(function (tags) {
              $scope.findADealer.loadingAddressAutocompletions = false;
              $scope.findADealer.autocompleteItemCount = tags.length;

              return tags;
            });
          };

          ctl.showFilteredDealers = function () {
            $scope.findADealer.serviceTypes.forEach(function (serviceType) {
              serviceType.savedCheckedState = serviceType.checked;
            });

            var filters = getFilterArray("Label");

            ctl.closeModal(true);
            ctl.track("Filters", $filter("formatArgs")("Show - {0}", [filters.length ? filters.join(", ") : "None"]));
            replaceDealersAndDisplay($scope.findADealer.dealersFiltered, false);
          };

          ctl.setLocation = function (tag) {
            // Override autocomplete default behaviour
            $scope.findADealer.searchOptions.tagfieldTags = [tag];
            $scope.findADealer.searchOptions.stateFilterActive = false;
            $scope.findADealer.searchOptions.location = {
              postcode: tag.tagInfo.postCode,
              suburb: tag.tagInfo.suburb,
              state: tag.tagInfo.state,
            };
            $scope.findADealer.refreshDealersAndUrlFragment();
            $scope.findADealer.tagfieldText = "";
            ctl.track("Postcode", tag.tagInfo.postCode);
          };

          ctl.removeLocation = function () {
            $scope.findADealer.searchOptions.tagfieldTags = [];
            $scope.findADealer.searchOptions.stateFilterActive = true;
            $scope.findADealer.searchOptions.location = null;
            $scope.findADealer.refreshDealersAndUrlFragment();
          };

          ctl.track = function (action, label) {
            var props = {
              event: "gaClick",
              eventCategory: "Find A Dealer",
              eventAction: action,
              eventLabel: label,
            };

            $analytics.eventTrack("gaClick", props);
          };

          function getUrlFragment() {
            var fragment = location.href.split("#")[1];
            return fragment ? decodeURIComponent(fragment) : null;
          }

          function setUrlFragment(urlFragment, replace) {
            var urlBase = location.href.split("#")[0];
            var encodedFragment = encodeURIComponent(urlFragment);
            if (replace) {
              history.replaceState({}, null, urlBase + "#" + encodedFragment);
            } else {
              history.pushState({}, null, urlBase + "#" + encodedFragment);
            }
          }

          function serializeSearchOptionsForFragment(searchOptions) {
            if (searchOptions.stateFilterActive && searchOptions.stateFilter) {
              return searchOptions.stateFilter;
            }

            if (searchOptions.location) {
              return "location";
            }

            return "none";
          }

          function deserializeSearchOptionsFromFragment(fragment) {
            if (!fragment || fragment === "none") {
              return {
                stateFilterActive: true,
                stateFilter: null,
                location: null,
                tagfieldTags: [],
              };
            }

            if (fragment.match(/location/)) {
              return {
                stateFilterActive: true,
                stateFilter: null,
                location: null,
                tagfieldTags: [],
              };
            }

            return {
              stateFilterActive: true,
              stateFilter: fragment,
              location: null,
              tagfieldTags: [],
            };
          }

          ctl.hasDisabledServiceType = function () {
            var allServiceTypesValid = $scope.findADealer.serviceTypes.every(function (serviceType) {
              return !serviceType.disabled;
            });

            return !allServiceTypesValid;
          };

          function getFilterArray(prop) {
            var checkedServiceTypes = $scope.findADealer.serviceTypes.filter(function (serviceType) {
              return serviceType.checked && !serviceType.disabled;
            });

            return checkedServiceTypes.map(function (serviceType) {
              return prop ? serviceType[prop] : serviceType.Service_Type_Name;
            });
          }

          function getAppliedFilterArray() {
            var checkedServiceTypes = $scope.findADealer.serviceTypes.filter(function (serviceType) {
              return serviceType.savedCheckedState && !serviceType.disabled;
            });

            return checkedServiceTypes.map(function (serviceType) {
              return serviceType.Service_Type_Name;
            });
          }

          function filterResults(dealers) {
            $scope.findADealer.dealersFiltered = dealers.filter(function (dealer) {
              return getFilterArray().every(function (filter) {
                return dealer.serviceTypes.indexOf(filter) !== -1;
              });
            });

            $scope.findADealer.dealersFilteredCount = $scope.findADealer.dealersFiltered.length;
          }

          function getActiveStateFilter() {
            return $scope.findADealer.searchOptions.stateFilterActive
              ? $scope.findADealer.searchOptions.stateFilter
              : null;
          }

          function getFilterFriendlySummary(activeStateFilter, activeLocation) {
            if (activeStateFilter) {
              return " for " + activeStateFilter;
            }

            if (activeLocation) {
              return (
                " for " +
                (activeLocation.suburb + ", " + activeLocation.postcode + " " + activeLocation.state).replace(
                  / /g,
                  "\xa0"
                )
              );
            }

            return "";
          }

          function refreshUrlFragment() {
            var newSearchOptions = serializeSearchOptionsForFragment($scope.findADealer.searchOptions);
            var oldSearchOptions = getUrlFragment();

            if (newSearchOptions !== oldSearchOptions) {
              setUrlFragment(newSearchOptions);
            }
          }

          function refreshDealersAndUrlFragment() {
            $scope.findADealer.dealersUnfiltered = [];
            $scope.findADealer.dealers = [];
            $scope.findADealer.dealersDisplayed = [];
            $scope.findADealer.showOnboarding = false;

            if ($scope.findADealer.loadingPromise) {
              $scope.findADealer.loadingPromise.cancel();
            }

            var query = $location.search();
            var showPricingTransparencyOptInOnly = !!query.dealerOptIn;

            var dealersUrl = $filter("formatArgs")(ToyotaConsts.API.Info.DealersByState, [
              $scope.findADealer.searchOptions.stateFilter,
              showPricingTransparencyOptInOnly,
            ]);

            if ($scope.findADealer.searchOptions.location) {
              dealersUrl = $filter("formatArgs")(ToyotaConsts.API.Info.Dealers, [
                $scope.findADealer.searchOptions.location.postcode,
                $scope.findADealer.searchOptions.location.suburb,
                showPricingTransparencyOptInOnly,
              ]);
            }

            if (!$scope.findADealer.searchOptions.stateFilter && !$scope.findADealer.searchOptions.location) {
              replaceDealersAndDisplay([], true);
              return;
            }

            refreshUrlFragment();

            var cache = $scope.findADealer.cached[dealersUrl];
            if (cache) {
              scrollToSearchResult();
              if ($scope.findADealer.searchOptions.location) {
                replaceDealersAndDisplay(cache, false);
                return;
              }

              $scope.findADealer.dealersUnfiltered = cache;
              updateValidServiceTypes(cache);
              ctl.resetAppliedFilter();
              return;
            }

            scrollToSearchResult();

            $scope.findADealer.loadingDealers = true;
            $scope.findADealer.showDealersCount = false;

            var promise = API.get(dealersUrl);

            $scope.findADealer.loadingPromise = promise; // because finally() doesn't return the promise, we gotta do this

            promise
              .then(
                // success
                function (req) {
                  if (req && req.data && req.data.results.length > 0) {
                    var dealers = processDealersRaw(req.data.results);
                    $scope.findADealer.cached[dealersUrl] = dealers;

                    if ($scope.findADealer.searchOptions.location) {
                      replaceDealersAndDisplay(dealers, false);
                    }

                    $scope.findADealer.dealersUnfiltered = dealers;
                    updateValidServiceTypes(dealers);
                    ctl.resetAppliedFilter();
                    return;
                  }

                  if (req && req.data && !req.data.results.length) {
                    replaceDealersAndDisplay([], false);
                  }
                },
                // failed
                function () {
                  return undefined;
                }
              )
              .finally(function () {
                $scope.findADealer.loadingDealers = false;
                $scope.findADealer.showDealersCount = true;
              });
          }

          function validateUrl(url) {
            if (!url) return false;

            var isValid = urlRegexPattern.test(url);
            if (!isValid) return false;

            // assuming if .com.au or .com appear twice is an invalid url
            return isValidDealerUrl(url, ".com.au") && isValidDealerUrl(url, ".com");
          }

          function isValidDealerUrl(url, extension) {
            const parts = url.split("/");
            const domainWithExtension = parts.filter(part => part.endsWith(extension));
            const domainCount = new Set(domainWithExtension).size;
        
            return domainCount <= 1;
          }

          function filterServiceTypes(types) {
            var includedServices = $scope.findADealer.serviceTypes.map(function (serviceType) {
              return serviceType.Service_Type_Name.toLowerCase();
            });

            return types.filter(function (type) {
              return includedServices.indexOf(type.toLowerCase()) >= 0;
            });
          }

          function updateValidServiceTypes(dealers) {
            var validServiceTypes = [];

            dealers.forEach(function (dealer) {
              dealer.servicesArray.forEach(function (serviceType) {
                if (validServiceTypes.indexOf(serviceType) >= 0) {
                  return;
                }

                var isValid = $scope.findADealer.serviceTypes.find(function (serviceTypeOption) {
                  return serviceTypeOption.Service_Type_Name === serviceType;
                });

                if (isValid) {
                  validServiceTypes.push(serviceType);
                }
              });
            });

            $scope.findADealer.serviceTypes.forEach(function (name) {
              var disabled = validServiceTypes.indexOf(name.Service_Type_Name) === -1;
              var serviceType = $scope.findADealer.serviceTypeFilter[name.Service_Type_Name];
              serviceType.disabled = disabled;
              serviceType.checked = !disabled && serviceType.savedCheckedState;
            });
          }

          function replaceDealersAndDisplay(_dealers, isOnboarding) {
            var dealers = _dealers.slice(0);

            function doWork() {
              $scope.findADealer.dealers = dealers;

              var totalDealers = dealers.length;
              var totalDealersOnLoad = Math.min(totalDealers, dealerCountPerLoad);

              $scope.findADealer.dealersFilteredCount = totalDealers;
              $scope.findADealer.showEmpty = totalDealers === 0 && !isOnboarding;
              $scope.findADealer.showOnboarding = isOnboarding;
              $scope.findADealer.showDealersCount = !isOnboarding;
              $scope.findADealer.dealersDisplayed = dealers.slice(0, totalDealersOnLoad);
              $scope.findADealer.allItemsDisplayed = totalDealers <= dealerCountPerLoad;

              /*
               * When switching to onboarding state, let current dealer
               * count fade away without changing to 'No dealers found'
               */
              if ($scope.findADealer.showDealersCount) {
                $scope.findADealer.dealersCountDisplayed = totalDealers;
                $scope.findADealer.filterFriendlySummary = getFilterFriendlySummary(
                  getActiveStateFilter(),
                  $scope.findADealer.searchOptions.location
                );
              }

              // this will ensure clicking the X button doesn't scroll viewport to search result
              if (totalDealers < 1) return;

              setTimeout(() => {
                scrollToSearchResult();
              }, 500);
            }

            if (!angular.element("html").hasClass("async-hide")) {
              $timeout(doWork);
            } else {
              var waitForAsyncHide = setInterval(function () {
                if (!angular.element("html").hasClass("async-hide")) {
                  $timeout(doWork(dealers));
                  clearInterval(waitForAsyncHide);
                }
              }, ASYNC_HIDE_DURATION_MS);
            }
          }

          function processDealersRaw(dealersRaw) {
            return dealersRaw
              .map(function (dealer) {
                var servicesArray = filterServiceTypes(dealer.serviceTypes);
                return angular.extend(
                  {
                    servicesArray: servicesArray,
                    services: servicesArray.join(", "),
                    serviceImages: filterServiceImages(dealer.serviceTypes),
                    addressUrl:
                      "https://www.google.com/maps/search/?api=1&query=" +
                      encodeURIComponent(
                        [dealer.name, dealer.address, dealer.city + " " + dealer.state, dealer.postCode].join(", ")
                      ),
                    telephoneUrl: "tel://" + dealer.telephone.replace(/\s/g, ""),
                    validatedUrl: validateUrl(dealer.webSite) ? dealer.webSite : "",
                  },
                  dealer
                );
              })
              .sort(function (a, b) {
                var cityA = a.city.toLowerCase();
                var cityB = b.city.toLowerCase();

                if (cityA < cityB) {
                  return -1;
                }

                if (cityA > cityB) {
                  return 1;
                }

                return 0;
              });
          }

          function filterServiceImages(types) {
            var includedServiceTypes = [
              { expressmaintenance: "Express Maintenance" },
              { fivestardealer: "5 Star Dealer" },
              { fleetspecialistdealer: "Fleet Specialist Dealer" },
            ];

            return includedServiceTypes.reduce(function (all, includedServiceType) {
              var key = Object.keys(includedServiceType)[0];
              all[key] = types.indexOf(includedServiceType[key]) >= 0;
              return all;
            }, {});
          }

          function displayMoreItems() {
            var totalDealers = $scope.findADealer.dealers.length;
            var maxDealersToShow = $scope.findADealer.dealersDisplayed.length + dealerCountPerLoad;
            var totalDealersOnLoad = Math.min(totalDealers, maxDealersToShow);

            var $html = angular.element("html");
            $html.css("overflow-anchor", "none");

            $scope.findADealer.dealersDisplayed = $scope.findADealer.dealers.slice(0, totalDealersOnLoad);

            if (totalDealers <= maxDealersToShow) {
              $scope.findADealer.allItemsDisplayed = true;
            }

            $timeout(function () {
              $html.css("overflow-anchor", "");
            });
          }

          function scrollToSearchResult() {
            var searchResultNode = document.querySelector(".ty-find-a-dealer-state-tabs");

            if (searchResultNode) {
              // Scroll the viewport to the element
              searchResultNode.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }
          }

          ctl.isFilterChecked = function (serviceType) {
            return $scope.findADealer.searchOptions.filters.indexOf(serviceType) >= 0;
          };

          ctl.resetServiceTypeFilter = function () {
            $scope.findADealer.serviceTypes.forEach(function (serviceType) {
              serviceType.checked = !serviceType.disabled && serviceType.savedCheckedState;
            });
            filterResults($scope.findADealer.dealersUnfiltered);
          };

          ctl.clearServiceTypeFilter = function () {
            ctl.track("Filters", "Clear All");
            $scope.findADealer.serviceTypes.forEach(function (serviceType) {
              serviceType.checked = false;
            });
            filterResults($scope.findADealer.dealersUnfiltered);
          };

          ctl.isClearFilterDisabled = function () {
            return getAppliedFilterArray().length === 0;
          };

          ctl.resetAppliedFilter = function () {
            $scope.findADealer.serviceTypes.forEach(function (serviceType) {
              serviceType.checked = false;
              serviceType.savedCheckedState = false;
            });
            replaceDealersAndDisplay($scope.findADealer.dealersUnfiltered, false);
          };

          ctl.isServiceTypeDisabled = function (serviceType) {
            return $scope.findADealer.serviceTypeFilter[serviceType].disabled;
          };

          ctl.$onInit = init;
        },
      ];

      return {
        scope: false,
        restrict: "A",
        controller: controller,
        controllerAs: "findADealerController",
      };
    },
  ]);
})(
  window.angular,
  window.location,
  window.history,
  window.encodeURIComponent,
  window.decodeURIComponent,
  window.setInterval,
  window.clearInterval,
  window.ToyotaConsts
);
